import { useEffect, useState } from "react"
import { PrintJson } from "../../../theme/Component/PrintJson";
import { _AccountHelpDesk, _HelpDesk, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { SelectAccountHelpDesk } from "./SelectAccountHelpDesk";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const HD002 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});
    const { _procedure, _pocessData, _exportMap, _pushInfo, _pushProps } = configProcedure;
    const _helpDesk = useDataBean(_HelpDesk);
    const _accountHelpDesk = useDataBean(_AccountHelpDesk);
    const { bean, setBean, lista, setLista, handleChange } = _helpDesk;

    const [caso, setCaso] = useState<any>({});
    const [tipo, setTipo] = useState<any>({});

    useEffect(() => {
        if (_pocessData.IDProcedureImp) {
            _helpDesk.getLista({ IDProcedureImp: _pocessData.IDProcedureImp }, null);

        }
    }, [_pocessData.IDProcedureImp])
    useEffect(() => {
        if (_helpDesk.lista.length > 0) {
            setCaso(_helpDesk.lista[0].DataBeanProperties);
        }

    }, [_helpDesk.lista])



    const asignarCaso = () => {
        
       

        if (tipo.IDAccountHelpDesk > 0) {
            if (_pushProps) {
                _pushProps(
                    {
                        AssignTo: tipo.IDAccount,
                        CLASIFICACION: bean.Rechazo === true ? 0 : tipo.IDAccountHelpDesk,
                        OBSRechazo: bean.OBS
                    }
                )
            }
            if (_exportMap) {
                _exportMap(
                    {
                        IDAccountCaso: tipo.IDAccount,
                        CLASIFICACION: bean.Rechazo === true ? 0 : tipo.IDAccountHelpDesk,
                        OBSRechazo: bean.OBS
                    }
                )
            }
            if (_pushInfo) {
                _pushInfo(
                    _single.jsonToBootstrapTable(
                        {
                            Asignado: tipo.AccountFullName ?? '---',
                            "Observaciones": bean.OBS ?? 'NA'
                        }
                    )
                )
            }


            if(caso)
            {                
                _helpDesk.updateCustonBean(caso).then(
                    (resp:any)=>{
                        _single.printOut(resp);
                    }
                )
            }

        } else {
            toast.warning("Debe seleccionar un responsable");
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Solicitud</label>
                <textarea className="form-control" readOnly value={caso.Observation}></textarea>
            </div>
            <div className="col-md-6">
                <SelectAccountHelpDesk idSelector={bean.IDHelpType} onChange={(e) => { setTipo(e);setCaso({...caso,"IDHelpType":e.IDAccountHelpDesk,"Description":e.Description}) }} label="Clasificación Solicitud" returnType="Object" />
            </div>
            <div className="col-md-6">
                <BasicSwitch label="Rechazar" estado={bean.Rechazo ?? false} eventChange={(e) => { setBean({ ...bean, "Rechazo": e }) }} />
                <span>{caso.Description}</span>
            </div>
            <div className="col-md-12">
                <label>Observaciones </label>
                <textarea name="OBS" className="form-control" onChange={handleChange} value={bean.OBS}></textarea>
            </div>
            <div className="col-md-6">
                <BasicButton icon="" useMargin eventClick={asignarCaso} >Guardar</BasicButton>
            </div>
            <div className="col-md-12">
                {/* <PrintJson json={lista} /> */}
                {/* <PrintJson json={tipo} /> */}
                {/* <PrintJson json={_pocessData} /> */}
            </div>
        </div>
    )
}